import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/page-header';
import { Routes } from 'src/components/common/router/constants';
import { UnauthorizedPage } from 'src/components/common/unauthorized';
import { ResourceDetails } from 'src/components/resource/details';
import {
  Actions,
  AppArea,
  ResourceByIdDocument,
  ResourceByIdQuery,
  Subjects,
} from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const UserResourceDetailsPage = () => {
  const { t } = useTranslation();

  const { id } = useParams();

  const { data, loading } = useQuery<ResourceByIdQuery>(ResourceByIdDocument, {
    variables: {
      id,
    },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  const breadCrumbsProps = {
    items: [
      {
        label: t('resources.breadcrumbs.resources'),
        url: Routes.resources.path,
      },
      {
        label: t('resources.list.user-resources-list'),
      },
    ],
  };

  const title = data?.resourceById?.name || '';
  const resource = data?.resourceById;

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <Can I={Actions.Read} a={Subjects.Resources} appArea={AppArea.Common}>
        {resource && <ResourceDetails resource={resource} />}
      </Can>
      <Can not I={Actions.Read} a={Subjects.Resources} appArea={AppArea.Common}>
        <UnauthorizedPage />
      </Can>
    </>
  );
};
